import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({});
  const [globalLoading, setGlobalLoading] = useState(false);
  const [globalMessage, setGlobalMessage] = useState('Loading...');

  const setLoading = useCallback((key, isLoading, message = '') => {
    setLoadingStates(prev => ({
      ...prev,
      [key]: {
        loading: isLoading,
        message: message || `${key}...`,
      },
    }));
  }, []);

  const setGlobalLoadingState = useCallback((isLoading, message = 'Loading...') => {
    setGlobalLoading(isLoading);
    setGlobalMessage(message);
  }, []);

  const isLoading = Object.values(loadingStates).some(state => state.loading) || globalLoading;

  const value = {
    setLoading,
    setGlobalLoading: setGlobalLoadingState,
    isLoading,
    loadingStates,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {globalLoading && (
        <div 
          className="global-loading-overlay"
          role="status"
          aria-live="polite"
          data-testid="global-loading"
        >
          <div className="global-loading-content">
            <div className="loading-spinner-large" />
            <p className="global-loading-message">{globalMessage}</p>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
};

export default LoadingProvider;
